module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjZThlYWVkIj48cGF0aCBkPSJNODAtMTYwdi0xNjBoMTYwdjE2MEg4MFptMjQwIDB2LTE2MGg1NjB2MTYwSDMyMFpNODAtNDAwdi0xNjBoMTYwdjE2MEg4MFptMjQwIDB2LTE2MGg1NjB2MTYwSDMyMFpNODAtNjQwdi0xNjBoMTYwdjE2MEg4MFptMjQwIDB2LTE2MGg1NjB2MTYwSDMyMFoiIGZpbGw9IiM3MEExRjAiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/assets-24px-active.svg
// module id = 4/Q2
// module chunks = 1